import React from "react";
import { Link } from "gatsby";
import { LocaleConsumer } from "../Layout";
import locales from "../../../config/i18n";

const LanguageSwitch = ({ ipCode, to, activeClassName, ...props }) => {
  return (
    <LocaleConsumer>
      {({ locale }) => {
        let currentPath = window.location.pathname + window.location.search;
        const newPath =
          typeof locales[locale] !== "undefined" && locales[locale].default
            ? `${to}${currentPath === "/" ? "" : currentPath}`
            : `${to}${
                to === `/`
                  ? currentPath === "/cn-zh" || currentPath === "/jp-ja"
                    ? ""
                    : currentPath.replace(`/${locales[locale].path}/`, "")
                  : currentPath.replace(`/${locales[locale].path}`, "")
              }`;
        return ipCode === "CN" || ipCode === "HK" ? (
          <a {...props} href={`https://tdcx.cn`} />
        ) : (
          <Link {...props} to={newPath} activeClassName={activeClassName} />
        );
      }}
    </LocaleConsumer>
  );
};

export default LanguageSwitch;
